import React from 'react';
import { CSSTransition } from 'react-transition-group';

import { SLIDE_VERTICAL_DURATION_MS, SLIDE_DOWN_TOTAL_MS } from './Animations';
import { localizedString, capitalize } from '../services/i18n/translations';

import { Wrapper, PreviousStep, ListTitle } from './common';
import TableList from '../library/TableList';

const SizesTable = ({
  sizingCharts,
  dispatch,
  submitNewReference,
  referenceBeingEdited,
  submitEditedReference,
  selectedBrand,
  selectedCategory
}) => {
  const onSelect = (size, chart) => {
    const toSubmit = {
      brand_id: chart.brand_id,
      name: chart.brand,
      brand_logo_url: selectedBrand.logoUrl,
      category: chart.category || selectedCategory,
      size_name: size.name,
      size_id: size.id,
      sizing_chart_id: chart.sizing_chart_id,
      sizing_chart_slug: chart.slug,
      gender: chart.gender
    };

    if (referenceBeingEdited) {
      submitEditedReference(toSubmit);
    } else {
      submitNewReference(toSubmit);
    }

    return dispatch({ type: 'SELECT_REFERENCE' });
  };

  const primaryCharts = sizingCharts.some(chart => chart.is_primary)
    ? sizingCharts.filter(chart => chart.is_primary)
    : sizingCharts.slice(0, 1);

  return (
    <>
      <Wrapper>
        <PreviousStep
          number="1"
          text={selectedBrand.name}
          onEdit={() => dispatch({ type: 'EDIT_BRAND' })}
          ariaLabel="edit brand choice"
          hideEdit={Boolean(referenceBeingEdited)}
        />
        <CSSTransition
          classNames="reference-slide-up"
          timeout={SLIDE_VERTICAL_DURATION_MS}
          in={true}
          appear={true}
          unmountOnExit={true}
        >
          <PreviousStep
            number="2"
            text={capitalize(localizedString(selectedCategory.translation_key))}
            onEdit={() => dispatch({ type: 'EDIT_CATEGORY' })}
            ariaLabel="edit category choice"
            hideEdit={Boolean(referenceBeingEdited)}
          />
        </CSSTransition>
        <CSSTransition
          classNames="reference-slide-down"
          timeout={SLIDE_DOWN_TOTAL_MS}
          in={true}
          appear={true}
          unmountOnExit={true}
        >
          <div>
            <ListTitle number="3" text="CHOOSE_SIZE" />
            {primaryCharts.map(chart => (
              <TableList
                key={chart.sizing_chart_id}
                items={chart.primary_system.sizes.map(s => s.name)}
                onSelect={sizeName => {
                  const size = chart.primary_system.sizes.find(s => s.name === sizeName);
                  onSelect(size, chart);
                }}
                previousItem={
                  referenceBeingEdited &&
                  chart.sizing_chart_id === referenceBeingEdited.sizing_chart_id &&
                  referenceBeingEdited.size_name
                }
              />
            ))}
          </div>
        </CSSTransition>
      </Wrapper>
    </>
  );
};

export default SizesTable;
